// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__4enlv","headingElement":"Heading_headingElement__V7FyG","animateHeading":"Heading_animateHeading__mszry"};